import { getUserId } from '../../utils/customer';
import { B2B_UPDATE_PAYMENT_PATH, B2B_BILLING_ADDRESS_PATH, B2B_PAYMENTS_RETRIEVE_PATH, B2B_PAYPAL_SET_CHECKOUT_PATH, B2B_PAYPAL_SAVE_PATH, B2B_UPDATE_STATUS_PATH, B2B_PAYMENTS_PATH, B2B_ADD_UPDATE_NICKNAME_PATH, B2B_PAYMENTS_PATH_WITH_USER_ID, B2B_STOP_ALL_AUTHORIZATION, B2B_ACCOUNT_CNP_ENROLLMENT, B2B_GIFT_CARD_BALANCE_PATH, B2B_GET_CITI_CARDS, B2B_ACCOUNT_RESEND_T2C_PATH, B2B_ACCOUNT_HD_WALLET_UNENROLLMENT, B2B_ACCOUNT_HD_WALLET_ENROLLMENT, B2B_PRO_HOUSE_ACCOUNT_RETRIEVE_PATH, B2B_PRO_HOUSE_ACCOUNT_T2C_UNENROLL_PATH, B2B_PRO_HOUSE_ACCOUNT_T2C_ENROLL_PATH, B2B_ACCOUNT_MULTI_RESEND_T2C_PATH, B2B_ADD_CHECKING_ACCOUNT_ENCRYPTED, B2B_PRO_HOUSE_ACCOUNT_WITH_USER_ID_SVOC_ID_PATH, B2B_PAYPAL_V2_SET_CHECKOUT_PATH, B2B_PAYPAL_V2_SAVE_PATH, PAYPAL_CANCEL_REDIRECT_PATH, PAYPAL_RETURN_PATH, } from '../../constants/links';
import { CNP_ENROLLMENT_ACTIONS, } from '../../models/b2b/payments';
import { CardType } from '../../constants/payments';
import { PAYMENTS_PAGE_SIZE } from '../../constants/general';
import { apiB2B } from '../axios-client';
// eslint-disable-next-line no-shadow
export var B2BCreditCardsFilterType;
(function (B2BCreditCardsFilterType) {
    B2BCreditCardsFilterType["nickName"] = "nickName";
    B2BCreditCardsFilterType["cardBrand"] = "cardBrand";
    B2BCreditCardsFilterType["cardLast4Digits"] = "cardLast4Digits";
    B2BCreditCardsFilterType["status"] = "status";
    B2BCreditCardsFilterType["expDate"] = "expDate";
    B2BCreditCardsFilterType["citiID"] = "citiID";
    B2BCreditCardsFilterType["NOTHING"] = "";
})(B2BCreditCardsFilterType || (B2BCreditCardsFilterType = {}));
export const B2BCreditCardsFilterTypePlaceHolder = {
    [B2BCreditCardsFilterType.nickName]: 'Enter Nickname',
    [B2BCreditCardsFilterType.cardLast4Digits]: 'Enter Last 4 Digits',
    [B2BCreditCardsFilterType.expDate]: 'MM/YY',
    [B2BCreditCardsFilterType.citiID]: 'Enter Last 4 Digits',
    [B2BCreditCardsFilterType.cardBrand]: 'Choose a Card Type',
    [B2BCreditCardsFilterType.status]: 'Choose a Status',
    [B2BCreditCardsFilterType.NOTHING]: '',
};
export const B2BApiCardType = {
    [CardType.CREDIT_CARD]: 'cc',
    [CardType.GIFT_CARD]: 'gc',
    [CardType.CHECKING_ACCOUNT]: 'ck',
    [CardType.KEY_TAG]: 'kt',
    [CardType.PRO_XTRA_DOLLARS]: 'pgc',
    [CardType.PAYPAL_ACCOUNT]: 'pba',
    [CardType.PRO_HOUSE_ACCOUNT]: 'cc',
};
export const b2bPaymentsApi = {
    getPHACards: () => {
        return apiB2B.get(B2B_PRO_HOUSE_ACCOUNT_RETRIEVE_PATH);
    },
    getPayments: (cardType, sortConfig, filterConfig) => {
        if ((filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.filterType) === B2BCreditCardsFilterType.citiID) {
            return apiB2B.get(B2B_GET_CITI_CARDS(filterConfig.filterValue), {
                params: {
                    typecd: B2BApiCardType[cardType],
                    ps: sortConfig.pageSize || PAYMENTS_PAGE_SIZE,
                    pn: sortConfig.page || 1,
                    sb: sortConfig.sortBy || 'lastedited',
                    asc: sortConfig.ascendingOrder || false,
                },
            });
        }
        return apiB2B.get(B2B_PAYMENTS_RETRIEVE_PATH, {
            params: {
                typecd: B2BApiCardType[cardType],
                ps: sortConfig.pageSize || PAYMENTS_PAGE_SIZE,
                pn: sortConfig.page || 1,
                sb: sortConfig.sortBy || 'lastedited',
                asc: sortConfig.ascendingOrder || false,
                filterType: filterConfig.filterType === B2BCreditCardsFilterType.NOTHING
                    ? undefined
                    : filterConfig.filterType,
                filterValue: filterConfig.filterValue || undefined,
            },
        });
    },
    getBillingAddress: (addressId, isPurchaser) => apiB2B.get(`${B2B_BILLING_ADDRESS_PATH}/${addressId}`, {
        params: {
            ownerUserId: isPurchaser ? getUserId() : undefined,
        },
    }),
    paypalInit: () => apiB2B.get(B2B_PAYPAL_SET_CHECKOUT_PATH),
    initPayPalV2: () => apiB2B.post(B2B_PAYPAL_V2_SET_CHECKOUT_PATH, {
        payPalAccountRequest: {
            cancelUrl: PAYPAL_CANCEL_REDIRECT_PATH,
            returnUrl: PAYPAL_RETURN_PATH,
            requestType: 'InitPaypal',
        },
    }),
    paypalSave: (token, paymentCard) => apiB2B.post(B2B_PAYPAL_SAVE_PATH, {
        savePayPalAccountRequest: {
            token,
            paymentCard,
        },
    }),
    savePayPalV2: (token, paymentCard) => apiB2B.post(B2B_PAYPAL_V2_SAVE_PATH, {
        payPalAccountRequest: {
            token,
            requestType: 'VerifyAndSave',
            paymentCard,
        },
    }),
    updatePayment: (payment, typeConfig) => {
        const payload = {
            paymentCardRequest: {
                paymentCard: payment,
            },
        };
        return apiB2B.put(B2B_UPDATE_PAYMENT_PATH, payload, {
            params: {
                typecd: B2BApiCardType[typeConfig],
            },
        });
    },
    addOrUpdateCardNickName: (payment, typeConfig) => {
        const payload = {
            paymentCardRequest: {
                paymentCard: payment,
            },
        };
        return apiB2B.put(B2B_ADD_UPDATE_NICKNAME_PATH, payload, {
            params: {
                typecd: B2BApiCardType[typeConfig],
            },
        });
    },
    getGiftCardBalance: (selectedGiftCard, pin, recaptcha) => {
        const payload = {
            paymentCardRequest: {
                paymentCard: Object.assign(Object.assign({}, selectedGiftCard), { pin,
                    recaptcha }),
            },
        };
        return apiB2B.post(B2B_GIFT_CARD_BALANCE_PATH, payload);
    },
    updateStatus: (payment, typeConfig) => {
        const payload = {
            paymentCardRequest: {
                paymentCard: payment,
            },
        };
        return apiB2B.put(B2B_UPDATE_STATUS_PATH, payload, {
            params: {
                typecd: B2BApiCardType[typeConfig],
            },
        });
    },
    deletePayment: (paymentId, typeConfig) => {
        return apiB2B.delete(`${B2B_PAYMENTS_PATH}/${paymentId}`, {
            params: {
                typecd: B2BApiCardType[typeConfig],
            },
        });
    },
    addPayment: (payment, typeConfig, recaptchaToken) => {
        const payload = {
            paymentCardRequest: {
                paymentCard: payment,
            },
        };
        const params = {
            params: {
                typecd: B2BApiCardType[typeConfig],
            },
        };
        const config = recaptchaToken
            ? Object.assign({ headers: {
                    'X-PAA-AUTH': recaptchaToken,
                } }, params) : Object.assign({}, params);
        return apiB2B.post(`${B2B_PAYMENTS_PATH_WITH_USER_ID}/add`, payload, config);
    },
    addCheckingAccountWithEncryption: ({ cardNickName, encryptedAccountNumber, routingNumber, }) => {
        const payload = {
            addCheckingAccountPaymentCardRequest: {
                cardNickName,
                encryptedAccountNumber,
                routingNumber,
            },
        };
        return apiB2B.post(B2B_ADD_CHECKING_ACCOUNT_ENCRYPTED, payload);
    },
    stopAllAuthorization: () => {
        return apiB2B.delete(`${B2B_STOP_ALL_AUTHORIZATION}`);
    },
    exportPaymentCardsToCSV: (typeConfig, fileName) => {
        return apiB2B.get(`${B2B_PAYMENTS_PATH}/csv/`, {
            params: {
                typecd: B2BApiCardType[typeConfig],
                fileName,
            },
            responseType: 'blob',
        });
    },
    printPaymentCardsToPDF: (typeConfig, fileName) => {
        return apiB2B.get(`${B2B_PAYMENTS_PATH}/pdf/`, {
            params: {
                typecd: B2BApiCardType[typeConfig],
                fileName,
            },
            responseType: 'blob',
        });
    },
    cnpEnrollmentRemoveAuth: (paymentId, group) => {
        const payload = {
            cnpEnrollmentRequest: {
                paymentCard: {
                    paymentId: paymentId || '',
                },
                cnpEnrollmentActions: CNP_ENROLLMENT_ACTIONS[group],
            },
        };
        return apiB2B.put(B2B_ACCOUNT_CNP_ENROLLMENT, payload);
    },
    unEnrollmentHDWallet: (card) => {
        const payload = {
            paymentCardRequest: {
                paymentCard: {
                    paymentId: card.paymentId,
                },
            },
        };
        return apiB2B.put(B2B_ACCOUNT_HD_WALLET_UNENROLLMENT, payload);
    },
    getPaymentById: (paymentId, cardType) => {
        return apiB2B.get(`${B2B_PAYMENTS_PATH}/${paymentId}`, {
            params: {
                typecd: B2BApiCardType[cardType],
            },
        });
    },
    hdPassAuthRequest: (data, recaptchaToken, deviceid) => {
        return apiB2B.put(B2B_ACCOUNT_HD_WALLET_ENROLLMENT, data, recaptchaToken
            ? {
                headers: { 'X-PAA-AUTH': recaptchaToken, deviceid },
            }
            : undefined);
    },
    phaUnenrollT2C: ({ paymentId, t2cApprovers, }) => {
        return apiB2B.put(B2B_PRO_HOUSE_ACCOUNT_T2C_UNENROLL_PATH, {
            paymentCardRequest: {
                paymentCard: {
                    paymentId,
                },
                t2cApprovers,
            },
        });
    },
    // this method now accepts t2cNumber or t2cApprovers but not both
    phaEnrollT2C: ({ t2cNumber, paymentId, t2cPrimary, isResend, t2cApprovers, }) => {
        return apiB2B.post(B2B_PRO_HOUSE_ACCOUNT_T2C_ENROLL_PATH, {
            paymentCardRequest: {
                paymentCard: {
                    t2cNumber,
                    paymentId,
                    t2cPrimary,
                },
                t2cApprovers,
            },
        }, {
            params: {
                isResend,
            },
        });
    },
    multiResendT2CRequest: (data) => {
        return apiB2B.post(B2B_ACCOUNT_MULTI_RESEND_T2C_PATH, data);
    },
};
export const resendT2CRequest = ({ t2cNumber, paymentId, t2cPrimary, }) => apiB2B.post(B2B_ACCOUNT_RESEND_T2C_PATH, {
    paymentCardRequest: {
        paymentCard: {
            t2cNumber,
            paymentId,
            t2cPrimary,
        },
    },
});
export const getUsersForTenderRequest = (paymentId) => {
    return apiB2B
        .get(`${B2B_PRO_HOUSE_ACCOUNT_WITH_USER_ID_SVOC_ID_PATH}/${paymentId}/authorized-users`)
        .then(({ data }) => data);
};
export const updateUsersForTenderRequest = (paymentId, request) => {
    return apiB2B
        .post(`${B2B_PRO_HOUSE_ACCOUNT_WITH_USER_ID_SVOC_ID_PATH}/${paymentId}/authorized-users`, request)
        .then(({ data }) => {
        return data;
    });
};
export const cnpEnrollmentRequest = (data, recaptchaToken) => {
    return apiB2B.put(B2B_ACCOUNT_CNP_ENROLLMENT, data, recaptchaToken
        ? {
            headers: { 'X-PAA-AUTH': recaptchaToken },
        }
        : undefined);
};
